<div class="dialog-box">
  <p class="modal-title">
    {{
      mode === "upload"
        ? "Upload Supporting Documents"
        : "Select relevant documents"
    }}
  </p>

  <p class="formats-info" *ngIf="mode === 'select'">
    Please select the relevant documents for this data point.
    <br />
    <span class="formats-allowed">
      Formats allowed are: <span class="format-list">pdf, jpg, xls</span>
    </span>
  </p>

  <div class="reference" *ngIf="mode === 'select'">
    <p>Reference page no (optional)</p>
  </div>

  <!-- ✅ If there are documents -->
  <div *ngIf="documents.length > 0; else emptyState">
    <div class="document-row" *ngFor="let doc of documents">
      <div
        class="doc-checkbox"
        [matTooltip]="shouldShowTooltip(doc.name) ? doc.name : ''"
      >
        <ng-container *ngIf="mode === 'select'; else uploadMode">
          <mat-checkbox [(ngModel)]="doc.selected" disableRipple>
            <span class="doc-name">
              <span class="doc-name-truncate">{{
                getTruncatedName(doc.name)
              }}</span>
              <span class="doc-ext">{{ getFileExtension(doc.name) }}</span>
            </span>
          </mat-checkbox>
        </ng-container>

        <ng-template #uploadMode>
          <span class="doc-name">
            <span class="doc-name-truncate">{{
              getTruncatedName(doc.name)
            }}</span>
            <span class="doc-ext">{{ getFileExtension(doc.name) }}</span>
          </span>
        </ng-template>
      </div>

      <button mat-icon-button class="view-icon" (click)="viewDocument(doc)">
        <mat-icon>visibility</mat-icon>
      </button>

      <input
        *ngIf="mode === 'select'"
        type="number"
        [(ngModel)]="doc.pageNo"
        min="0"
        (ngModelChange)="validatePageNo(doc)"
        placeholder="Page No"
        class="page-input"
      />
    </div>
  </div>

  <!-- ✅ Default message when no documents -->
  <ng-template #emptyState>
    <div class="empty-state">
      <mat-icon>insert_drive_file</mat-icon>
      <p>No supporting documents available</p>
      <small *ngIf="mode === 'upload'">
        Click <b>Add new document</b> to upload files.
      </small>
    </div>
  </ng-template>

  <div class="modal-actions">
    <input
      #fileInput
      type="file"
      accept=".pdf,.jpg,.jpeg,.xls,.xlsx"
      multiple
      style="display: none"
      (change)="onFileSelected($event)"
    />

    <button class="primary-button" (click)="handleAddDocumentClick(fileInput)">
      Add new document
    </button>

    <button class="primary-button" (click)="submit()">
      {{ mode === "upload" ? "Upload" : "Save" }}
    </button>

    <button class="cancel-button" (click)="close()">Cancel</button>
  </div>
</div>
